<template>
    <div>
        <common-table :limitHeight="true" :table-columns="tableColumns" :url="url" :operate="operate"
            :form-fields="formFields" :permission="permission" :buttons="buttons" :searchs="searchs"
            @returnId="returnId" @addCreateRule="addCreateRule" pageName="BalanceManage" ref="table"
            @isPageSmall="isPageSmall"></common-table>
        <el-drawer :visible.sync="showAddCreateRulePopup" :size="pageSmall ? '100%' : '50%'" direction="rtl"
            :withHeader="false">
            <div class="addCreateRuleBox ">
                <div class="createRuleTitle flex-between alcenter">
                    创建规则
                    <i class="el-icon-close" @click="closeRulePopup"></i>
                </div>
                <div class="setRuleContent">
                    <div class="oe-drawer-guide">
                        <guide-panel
                            dense
                            title="余额预警规则说明"
                            summary="这张表单用于给广告账户设置低余额提醒。命中阈值后系统会按你选择的联系人和频率发送通知，帮助你避免账户因为余额不足突然断投。"
                            icon="el-icon-warning-outline"
                            :points="[
                                '先选需要监控的账户，再设置余额阈值。',
                                '这个规则只负责提醒，不会自动充值。',
                                '建议同时配置多个联系人，并开启频率限制，避免漏接或刷屏。'
                            ]"
                        />
                    </div>
                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">规则名称</span>
                        <el-input class="input250 w300" v-model="ruleName" placeholder="请输入规则名称" />
                    </div>

                    <div class="oe-drawer-form-row">
                        <span class="oe-drawer-form-label">请选择代理</span>
                        <el-select size="medium" v-model="selectAgentId" placeholder="请选择代理" clearable filterable>
                            <el-option v-for="(option, index) in agentList" :key="index" :label="option.username"
                                :value="option.id" />
                        </el-select>
                    </div>
                    <div class="monitorTargetBox pt10">
                        <div class=" ">
                            <div class="flex alcenter">
                                <el-input v-model="searchKeyWord" @clear="searchAccountList = []; isSearching = false"
                                    clearable placeholder="搜索账户名称或ID" size="medium" class="handle-input2  mb-10" />
                                <el-button class="mb-10 fs18" type="primary" size="small" @click="gosearchAccountList">
                                    搜索
                                </el-button>
                            </div>
                            <div class="selectAccountBox pt10">
                                <div class="selectTitleBox flex alcenter">
                                    <div class="leftTitle flex alcenter">
                                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                            @change="handleCheckAllChange">
                                        </el-checkbox>
                                        <span class="pr10 pl10">请选择账户({{ accountList.length }})</span>
                                        <el-tooltip class="item" effect="dark" content="最多展示前200条，如果列表没有某条数据，请使用搜索减小范围"
                                            placement="top">
                                            <i class="el-icon-question mt5"></i>
                                        </el-tooltip>
                                    </div>
                                    <div class="rightTitle flex-between">
                                        <div>
                                            已选账户 <span v-if="selectedAccountList.length">( {{ selectedAccountList.length
                                            }}
                                                )</span></div>
                                        <div class="c_primary" v-if="selectedAccountList.length"
                                            @click="deleteselectedAccountList('')">
                                            清空
                                        </div>
                                    </div>

                                </div>
                                <div class="selectContentBox flex">
                                    <div class="left" v-loading="loading">
                                        <el-checkbox-group v-model="checkedAccount" @change="handleCheckedCitiesChange">
                                            <div class="flex alcenter  pb20"
                                                v-for="(item, index) in isSearching ? searchAccountList : accountList"
                                                :key="index">
                                                <el-checkbox :label="item">
                                                    <div class="pl5 ">
                                                        <div
                                                            :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                            {{ item.name }}</div>
                                                        <div class="c_999 " :class="pageSmall ? 'fs12' : ' fs14'">
                                                            ID:{{ item.advertiserId }}
                                                        </div>
                                                    </div>
                                                </el-checkbox>
                                            </div>
                                        </el-checkbox-group>
                                        <div class="pt50 nodata flex-center"
                                            v-if="isSearching ? !searchAccountList.length : !accountList.length">
                                            暂无数据
                                        </div>
                                    </div>
                                    <div class="left p5" v-loading="loading">
                                        <div class="flex-between alcenter selectedAccountBox pb20 mb10"
                                            v-for="(item, index) in selectedAccountList" :key="index">
                                            <div class="pl5 ">
                                                <div :class="pageSmall ? 'overflow1_120 fs16' : 'overflow1_300 fs18'">
                                                    {{ item.name }}</div>
                                                <div class="c_999 " :class="pageSmall ? 'fs12' : ' fs14'">
                                                    ID:{{ item.advertiserId }}
                                                </div>
                                            </div>
                                            <i class="el-icon-error" @click="deleteselectedAccountList(index)"></i>
                                        </div>
                                        <div class="pt50 nodata flex-center" v-if="!selectedAccountList.length">
                                            暂无数据
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="monitorTargetBox pt10">
                        <div class="font-bold">计划白名单</div>
                        <div class="pt10">
                            <el-select v-model="planWhiteList" multiple filterable allow-create default-first-option
                                clearable collapse-tags class="input400 input_h35"
                                @change="planWhiteList = normalizePlanWhiteList(planWhiteList)"
                                placeholder="输入计划ID后回车确认；已保存的计划白名单会在这里回显">
                                <el-option v-for="item in planWhiteListOptions" :key="item.value"
                                    :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                            <div class="pt10 c_999">
                                命中白名单的计划不会被当前余额规则处理；如列表中没有目标计划，可直接手动输入计划ID。
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section">
                        执行条件：所监控账户余额≤
                        <el-input class="w150 input150" v-model="balanceMin" placeholder="请输入" suffix-icon="元"
                            size="medium" />元
                    </div>
                    <div class="oe-drawer-section flex alcenter">
                        <span class="pr20 ">
                            执行动作
                        </span>
                        <div>
                            <el-checkbox :style="{ 'transform: scale(1.2);': !pageSmall }" v-model="wxNotice">
                                微信通知
                            </el-checkbox>
                            <div v-if="!wxNotice" class="c_ff3939 pt10">
                                请选择通知方式
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section flex" v-if="wxNotice">
                        <span class="pr10 pt10">
                            微信联系人
                        </span>
                        <div>
                            <div>
                                <el-select :class="pageSmall ? 'input200' : 'w400 input400'" multiple
                                    v-model="wxContracts" filterable placeholder="请选择联系人">
                                    <el-option v-for="item in wxContractsOptions" :key="item.wechatName"
                                        :label="item.wechatName" :value="item.openId">
                                    </el-option>
                                </el-select>
                                <span class="pl20 c_primary" @click="goAddContrats">添加联系人</span>
                            </div>
                            <div class="flex alcenter flex_wrap pt10">
                                <el-switch class="mr10" :style="{ 'transform: scale(1.1);': !pageSmall }"
                                    v-model="isLimitWXNotice">
                                </el-switch>
                                限制通知频率，每条计划
                                <el-select v-model="wxNoticeTimeValue" :disabled="!isLimitWXNotice" class="ml5 input150"
                                    placeholder="请选择" :class="pageSmall ? 'mt20' : ''">
                                    <el-option v-for="(item, index) in wxNoticeTimeList" :key="index" :label="item.name"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                                <div :class="pageSmall ? 'mt20' : ''">
                                    内最多通知一次
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="oe-drawer-section oe-drawer-section--bottom">
                        <span>监控状态</span>
                        <el-select class="pl10 input250" v-model="monitorStatus" placeholder="请选择">
                            <el-option v-for="item in monitorStatusList" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="drawer_footer flex-end alcenter">
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="closeRulePopup">
                        取消
                    </el-button>
                    <el-button class="mb-10 fs18" round type="primary" size="small" @click="goAddRule">
                        确定
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";
import GuidePanel from "@/components/GuidePanel/GuidePanel";
import {
    buildMonitorObjectInfo,
    buildPlanWhiteListOptions,
    normalizePlanWhiteList,
    parseMonitorObjectInfo
} from "@/utils/smartRoiRuleFormHelper";

export default {
    name: 'BalanceManage',
    components: { CommonTable, GuidePanel },
    data() {
        return {
            agentList: [],
            selectAgentId: '',
            loading: false,
            isSearching: false,
            // 营销目标
            editData: {},
            searchKeyWord: null,
            monitorWayList: [
                {
                    wayName: '账户',
                    info: '监控账户下所有计划'
                },
                {
                    wayName: '计划',
                    info: '监控指定计划'
                },
                {
                    wayName: '抖音号',
                    info: '监控抖音号下的计划'
                },
                {
                    wayName: '商品',
                    info: '监控指定商品下的计划'
                },
            ],
            // 监控目标
            checkAll: false,
            checkedAccount: [],
            accountList: [],
            selectedAccountList: [],
            searchAccountList: [],
            planWhiteList: [],
            planWhiteListOptions: [],


            // 执行时段
            activeTimePeriodBox: 0,
            timeSelectActiveList: [],
            // 监控状态
            monitorStatus: '启用',
            monitorStatusList: ['启用', '停用'],

            // 规则名称
            ruleName: '',

            // 执行条件
            balanceMin: '',

            // 执行动作
            isWxNotice: false,


            isIndeterminate: true,
            showAddCreateRulePopup: false,
            selectIds: [],
            selectProductIds: [],
            visible: false,
            advertiserList: [],
            douyinIds: [],
            currentDouyinList: [],
            updateForm: {
                advertiserId: '',
                douyinId: ''
            },
            creatVisible: false,
            creatForm: {
                advertiserId: '',
                aweMeId: '',
                roi: '',
                budget: '',
                productId: ''
            },

            creatTaskVisible: false,
            creatTaskForm: {
                advertiserId: '',
                aweMeId: '',
                roi: '',
                budget: '',
                productId: ''
            },
            searchs: [{
                name: 'monitorStatus',
                placeholder: '监控状态',
                type: 'select',
                select: true,
                selectData: [],
                selectValue: [{
                    value: '关闭',
                    key: 0
                }, {
                    value: '开启',
                    key: 1
                }]
            }, {
                name: 'createPerson',
                placeholder: '创建人',
                type: 'select',
                select: true,
                selectUrl: '/agent/getAll',
                selectData: [],
            }, {
                name: 'ruleName',
                placeholder: '规则名称',
                type: 'input'
            }],
            permission: {
                add: 'launchTheProduct:add',
                update: 'launchTheProduct:update',
                delete: 'launchTheProduct:delete',
                deleteBatch: 'launchTheProduct:deleteBatch'
            },
            url: {
                get: '/smartRoiRules/listByCondition?intelligentRegulationType=2',
                // add: '/launchTheProduct/add',
                // update: '/launchTheProduct/update',
                // delete: '/launchTheProduct/delete',
                // delete_batch: '/launchTheProduct/deleteBatch',
                // status: '/launchTheProduct/status',
            },
            tableColumns: [{
                field: 'status',  // 字段名
                label: '状态',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                status: true,  // 是否展示
            }, {
                field: 'ruleName',  // 字段名
                label: '规则名称',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'accountNum',  // 字段名
                label: '监控方式',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                tableType: 'monitorMode'
            }, {
                field: 'ruleInfo',  // 字段名
                label: '规则详情',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
                width: 600
            }, {
                field: 'executeAction',  // 字段名
                label: '执行动作',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,  // 是否展示
            }, {
                field: 'createPerson',  // 字段名
                label: '创建人',  // 字段显示名称
                sort: false,  // 是否排序
                show: true,
            }],
            formFields: {
                addTitle: '添加',
                updateTitle: '修改',
                model: [
                    {
                        field: 'id',  // 字段名
                        label: 'ID',  // 字段显示名称
                        type: 'input',
                        add: false,  // 是否添加
                        update: true
                    },
                    {
                        field: 'agentId',  // 字段名
                        label: 'agentId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入agentId',
                        rules: [
                            { required: true, message: 'agentId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'userId',  // 字段名
                        label: 'userId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入userId',
                        rules: [
                            { required: true, message: 'userId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'advertiserId',  // 字段名
                        label: 'advertiserId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入advertiserId',
                        rules: [
                            { required: true, message: 'advertiserId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'aweMeId',  // 字段名
                        label: 'aweMeId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入aweMeId',
                        rules: [
                            { required: true, message: 'aweMeId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productId',  // 字段名
                        label: 'productId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productId',
                        rules: [
                            { required: true, message: 'productId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'productName',  // 字段名
                        label: 'productName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入productName',
                        rules: [
                            { required: true, message: 'productName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'img',  // 字段名
                        label: 'img',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入img',
                        rules: [
                            { required: true, message: 'img不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'tag',  // 字段名
                        label: 'tag',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入tag',
                        rules: [
                            { required: true, message: 'tag不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'categoryName',  // 字段名
                        label: 'categoryName',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入categoryName',
                        rules: [
                            { required: true, message: 'categoryName不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'sellNum',  // 字段名
                        label: 'sellNum',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入sellNum',
                        rules: [
                            { required: true, message: 'sellNum不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'grayReason',  // 字段名
                        label: 'grayReason',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入grayReason',
                        rules: [
                            { required: true, message: 'grayReason不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'squareImageList',  // 字段名
                        label: 'squareImageList',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入squareImageList',
                        rules: [
                            { required: true, message: 'squareImageList不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelId',  // 字段名
                        label: 'channelId',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelId',
                        rules: [
                            { required: true, message: 'channelId不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    }, {
                        field: 'channelType',  // 字段名
                        label: 'channelType',  // 字段显示名称
                        type: 'input',
                        placeholder: '请输入channelType',
                        rules: [
                            { required: true, message: 'channelType不能为空', trigger: 'blur' }
                        ],
                        add: true,
                        update: true,
                    },
                ]
            },
            operate: [{
                icon: 'el-icon-edit',
                type: 'text',
                text: '编辑',
                handle: (row) => {
                    console.log(row)
                    this.showAddCreateRulePopup = true
                    this.editData.id = row.id
                    this.editData.monitoringTime = row.executeContent.monitoringTime

                    this.monitorStatus = row.status ? '启用' : '停用'
                    // this.activeWayBoxIndex = JSON.parse(row.monitorType) - 1
                    this.balanceMin = row.executeContent.balanceMin
                    let arr = []
                    this.accountList.forEach((obj) => {
                        if (row.monitorObject.includes(obj.advertiserId)) {
                            arr.push(obj)
                        }
                    })
                    if (arr.length) {
                        this.checkedAccount = arr
                        this.handleCheckedCitiesChange(arr)
                    }
                    this.restoreMonitorObjectInfo(row.executeContent && row.executeContent.monitorObjectInfo)
                    this.ruleName = row.ruleName
                    this.selectAgentId = row.userId
                    this.wxContracts = row.noticeConfig && row.noticeConfig.wxNumber
                    if (row.noticeConfig && row.noticeConfig.interval) {
                        this.isLimitWXNotice = true
                        this.wxNoticeTimeValue = row.noticeConfig.interval
                    }

                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '删除',
                handle: (row) => {
                    console.log(row)
                    this.$axios.post({
                        url: 'smartRoiRules/delete/' + row.id,
                        success: (res) => {
                            // this.loading = false
                            console.log('333', res)
                            if (res.code == 0) {
                                this.$message.success('删除成功')
                                // this.showAddCreateRulePopup = false
                                this.$refs.table.getData()
                            } else {
                                // this.$message.error(res.msg || '出错了')

                            }
                        },
                        error: () => {
                            this.loading = false
                            this.$message.error('出错了')
                        },
                    })
                }
            }, {
                icon: 'el-icon-edit',
                type: 'text',
                text: '日志',
                handle: (row) => {
                    console.log(row)
                    this.$router.push({
                        path: '/qdd/admin/SmartRoiRuleLogs.html',
                        query: { id: row.id, getLog: true }
                    })
                }
            }],
            buttons: [
                {

                }
            ],
            pageSmall: false,
            // 通知方式
            wxNotice: true,
            wxContracts: [],
            wxContractsOptions: [],
            isLimitWXNotice: false,
            wxNoticeTimeValue: 30,
            wxNoticeTimeList: [{
                name: '每30分钟',
                value: 30
            }, {
                name: '每1小时',
                value: 60
            }, {
                name: '每3小时',
                value: 180
            }, {
                name: '每6小时',
                value: 360
            }],
        }
    },
    mounted() {
        this.getADAccountList()
        this.getWxcontractsList()
        this.getAgentList()
    },
    beforeDestroy() {
        // window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        normalizePlanWhiteList,
        mergePlanWhiteListOptions(planWhiteList) {
            const optionMap = {}
            this.planWhiteListOptions.forEach((item) => {
                if (!item || item.value === undefined || item.value === null) return
                optionMap[item.value] = item
            })
            buildPlanWhiteListOptions(planWhiteList).forEach((item) => {
                optionMap[item.value] = item
            })
            this.planWhiteListOptions = Object.values(optionMap)
        },
        restoreMonitorObjectInfo(monitorObjectInfo) {
            const { selectedMonitorList, planWhiteList } = parseMonitorObjectInfo(monitorObjectInfo)
            this.planWhiteList = normalizePlanWhiteList(planWhiteList)
            this.mergePlanWhiteListOptions(this.planWhiteList)
            return selectedMonitorList
        },
        getAgentList() {
            this.$axios.post({
                url: '/agent/getAll',
                success: (res) => {
                    this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.agentList = res.data
                        console.log('333', this.agentList)

                    } else {
                        this.$message.error(res.msg || '出错了')

                    }
                    //          
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },

        goAddContrats() {
            this.showAddCreateRulePopup = false
            setTimeout(() => {
                this.$router.push({
                    path: '/qdd/admin/contacts.html',
                })
            }, 1)
        },

        getWxcontractsList() {
            this.$axios.post({
                url: '/wechatUser/getAll',
                success: (res) => {
                    // this.loading = false
                    console.log('666', res)
                    if (res.code == 0) {
                        this.wxContractsOptions = res.data
                    } else {
                        this.$message.error(res.msg || '出错了')
                    }
                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })
        },
        isPageSmall(data) {
            this.pageSmall = data;
            console.log(this.pageSmall)
        },
        selectTimeBox(num) {
            if (!this.timeSelectActiveList.includes(num)) {
                this.timeSelectActiveList.push(num)
            } else {
                let index = this.timeSelectActiveList.findIndex((obj) => obj == num)
                this.timeSelectActiveList.splice(index, 1)
            }
        },
        returnId(data) {
            this.selectIds = data;
            console.log(this.selectIds)
        },
        addCreateRule() {
            this.showAddCreateRulePopup = true;
        },
        closeRulePopup() {
            this.editData = {}
            this.isSearching = false
            this.balanceMin = ''
            this.searchKeyWord = ''
            this.checkAll = false
            this.checkedAccount = []
            this.selectedAccountList = []
            this.planWhiteList = []
            this.planWhiteListOptions = []
            this.wxContracts = []
            this.wxNotice = true
            this.isLimitWXNotice = false
            this.wxNoticeTimeValue = 30
            this.monitorStatus = '启用'
            this.ruleName = ''
            this.selectAgentId = ''
            this.showAddCreateRulePopup = false
        },
        inputBlur(e, index) {
            console.log(e, index, 'inputBlur')
            if (e <= this.stairsList[index].minValue) {
                this.$set(this.stairsList[index], 'wholePayNum', JSON.parse(this.stairsList[index].minValue) + 0.01)
            }
        },
        ordersChange() {
            // console.log(this.executeConditionList)
            let list = []
            this.executeConditionList.forEach((obj) => {
                list.push(obj.ordersValue)
            })
            this.ordersList.forEach((obj) => {
                if (list.includes(obj.name)) {
                    obj.disabled = true
                    // this.$set(this.ordersList)
                } else {
                    obj.disabled = false

                }
            })
        },

        processDate(targetDate) {
            const now = new Date();
            // 创建目标日期的纯日期部分（去除时间）
            const targetDateOnly = new Date(
                targetDate.getFullYear(),
                targetDate.getMonth(),
                targetDate.getDate()
            );

            // 创建当前日期的纯日期部分（去除时间）
            const todayOnly = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate()
            );

            console.log(targetDateOnly.getTime() === todayOnly.getTime(), now, '555555')
            if (targetDateOnly.getTime() === todayOnly.getTime()) {
                // 如果是今天：返回当前完整时间（年月日时分秒）

                const year = now.getFullYear()
                const month = String(now.getMonth() + 1).padStart(2, '0')
                const day = String(now.getDate()).padStart(2, '0')
                // const hours = String(now.getHours()).padStart(2, '0')
                // const minutes = String(now.getMinutes()).padStart(2, '0')
                // const seconds = String(now.getSeconds()).padStart(2, '0')
                return `${year}-${month}-${day}`
            } else {
                const year_end = targetDate.getFullYear()
                const month_end = String(targetDate.getMonth() + 1).padStart(2, '0')
                const day_end = String(targetDate.getDate()).padStart(2, '0')
                return `${year_end}-${month_end}-${day_end}`
            }
        },
        goAddRule() {


            if (!this.ruleName) {
                this.$message.error('请输入规则名称')
                return

            }

            if (!this.selectAgentId) {
                this.$message.error('请选择代理')
                return
            }
            if (!this.selectedAccountList.length) {
                this.$message.error('请选择广告账户')
                return
            }

            if (!this.balanceMin) {
                this.$message.error('请完善执行条件')
                return

            }


            if (!this.wxContracts.length) {
                this.$message.error('请选择联系人')
                return

            }


            let ids = []
            this.selectedAccountList.forEach((obj) => {
                if (!this.activeWayBoxIndex) {
                    ids.push(obj.advertiserId)
                } else if (this.activeWayBoxIndex == 1) {
                    ids.push(obj.adId)
                } else if (this.activeWayBoxIndex == 2) {
                    ids.push(obj.id)
                } else if (this.activeWayBoxIndex == 3) {
                    ids.push(obj.id)
                }
            })
            let noticeConfig = {  //通知设置，如通知设置传0则为不通知
                wxNumber: this.wxContracts,  //通知微信号
                interval: this.isLimitWXNotice ? this.wxNoticeTimeValue : 0  //限制的通知频率，为0则不限制
            }

            let executeContent = {
                balanceMin: this.balanceMin,//余额小于多少
                monitorObjectInfo: buildMonitorObjectInfo(this.selectedAccountList, this.planWhiteList),
            }
            const now = new Date();
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            const day = String(now.getDate()).padStart(2, '0')
            const hours = String(now.getHours()).padStart(2, '0')
            const minutes = String(now.getMinutes()).padStart(2, '0')
            const seconds = String(now.getSeconds()).padStart(2, '0')
            let monitoringTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`

            if (this.editData.monitoringTime) {
                executeContent.monitoringTime = this.editData.monitoringTime
            } else {
                executeContent.monitoringTime = monitoringTime
            }
            console.log(executeContent)
            let data = {
                userId: this.selectAgentId,
                ruleName: this.ruleName,
                marketingTarget: 0,
                monitorType: 1,
                status: 1,
                monitorObject: ids,
                planWhitelist: JSON.stringify(this.planWhiteList),
                executeContent: JSON.stringify(executeContent),
                noticeConfig: JSON.stringify(noticeConfig),
                intelligentRegulationType: 2,
                monitorAdvertiserId: this.selectedAccount,
            }
            console.log(data)
            let url
            if (this.editData.id) {
                data.id = this.editData.id
                url = 'smartRoiRules/update'
            } else {
                url = 'smartRoiRules/add'
            }
            this.$axios.post({
                url: url,
                data,
                success: (res) => {
                    // this.loading = false
                    console.log('333', res)
                    if (res.code == 0) {
                        this.closeRulePopup()
                        this.$refs.table.getData()
                    } else {
                        this.$message.error(res.msg || '出错了')

                    }


                },
                error: () => {
                    this.loading = false
                    this.$message.error('出错了')
                },
            })


        },
        handleCheckAllChange(e) {
            console.log(e)
            this.checkedAccount = e ? this.accountList : []
            this.selectedAccountList = this.checkedAccount
            this.isIndeterminate = false
            console.log(this.isIndeterminate, 'this.isIndeterminate')
        },
        handleCheckedCitiesChange(e) {
            console.log(e, this.checkedAccount)
            this.selectedAccountList = e
            this.checkAll = e.length === this.accountList.length
            this.isIndeterminate = e.length > 0 && e.length < this.accountList.length
        },
        deleteselectedAccountList(index) {
            console.log(index, index)
            if (index === '') {
                this.handleCheckAllChange(false)
            } else {
                this.checkedAccount = this.checkedAccount.slice(0, index).concat(this.checkedAccount.slice(index + 1));
                this.selectedAccountList = this.checkedAccount
            }
            this.checkAll = false
        },
        gosearchAccountList() {
            if (!this.searchKeyWord) return
            this.isSearching = true
            this.searchAccountList = []
            this.accountList.forEach((obj) => {
                if (obj.name.includes(this.searchKeyWord) || JSON.stringify(obj.advertiserId).includes(this.searchKeyWord)) {
                    this.searchAccountList.push(obj)
                }
            })

            console.log(this.searchAccountList)
        },
        getADAccountList() {
            this.$axios.post({
                url: '/oceanEngineAdvertiser/getAllInfo',
                success: (res) => {
                    console.log('333', res)
                    this.accountList = res.data
                },
                error: () => {
                    this.$message.error('出错了')
                },
            })
        },
        executeConditionChange(listIndex, index) {
            this.$set(this.executionList[listIndex], 'disabled', false)
            this.$set(this.executeConditionList[index], 'choosedIndex', JSON.stringify(listIndex))
            console.log(this.executionList, 'obj==')
            // console.log(obj, 'obj==')
        },
    }
}
</script>

<style scoped>
@import "../../styles/ocean-engine-rule-drawer.css";

* {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}


.createRuleTitle {
    font-weight: 600;
}

.createRuleTitle i {
    cursor: pointer;
}

.setRuleContent {
    overflow: scroll;
    height: 90vh;
}


/* 营销目标 */

.marketingBox {
    padding: 8px 20px;
    color: #ddd;
    cursor: not-allowed;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-left: none;
    border-radius: 0 5px 5px 0;
}

.marketingObjectives_box div:first-child {
    border-radius: 5px 0 0 5px;
}

.activeMarketingBox {
    background-color: #409eff;
    color: #fff;
}



.monitorWayBox,
.monitorTargetBox {
    padding: 14px 20px;
}

.monitorWayBox i {
    color: #409eff;
}

.monitorWayBox .way_box {
    cursor: pointer;
    width: 220px;
    /* height: 80px; */
    padding: 20px 0;
    border: 1px solid #ddd;
    color: #333;
    border-radius: 5px;
}

.monitorWayBox .way_info {
    color: #666;
}

.active_way_box {
    border-color: #346bf6 !important;
    color: #346bf6 !important;
}

.monitorTargetBox .monitorTargetContent {
    background-color: #f9f9f9;
    border-radius: 5px;
    padding: 15px;
}


/deep/ .monitorTargetBox .monitorTargetContent .el-button {
    border-radius: 0 50px 50px 0;
    height: 36px;
    width: 70px;
}

.handle-input2 {
    width: 300px !important;
}


.selectTitleBox .leftTitle,
.rightTitle {
    font-size: 17px !important;
    /* font-weight: 600 !important; */
    width: 50%;
    background-color: #f0f2f5;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
}

.selectContentBox {
    background-color: #fff;
    border-left: 1px solid #d9d9d9;
    border-right: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
}

.selectContentBox .accountBox {
    height: 30px;
}

.selectContentBox .left {
    width: 50%;
    padding: 10px;
    height: 250px;
    overflow: scroll;
}



.selectContentBox .nodata {
    /* width: 100%; */
    padding: 10px;
    height: 90%;
}

.selectedAccountBox {
    background-color: #edf4ff;
    padding: 10px;
}

.selectedAccountBox i {
    color: #409eff;
    cursor: pointer;
}

.yuan_box {
    position: absolute;
    top: 5px;
    right: 5px;
}

.addCondition {
    background-color: #edf4ff;
    padding: 5px 0;
    width: 500px;
    color: #4389f9;
    cursor: pointer;
}

.w100 {
    width: 100px;
}

.w150 {
    width: 150px;
}



.yl-time-range-table {
    border-collapse: collapse;
    table-layout: fixed;
    -webkit-user-select: none;
    user-select: none;
    border-radius: 4px;
    width: 573px;
    border: 1px solid #e4e9ed;
    background-color: #fff;
}

.table_head {
    background-color: #f0f2f5;
    color: #555;
    /* padding: 10px; */
    text-align: center;
}

.time_select_box {
    cursor: pointer;
}

.time_select_box_inactive:hover {
    background-color: #f0f2f5;
}

.time_select_box_active {
    background-color: #409eff;
}

.drawer_footer {
    z-index: 1;
    background: #fff;
    align-items: center;
    height: 64px;
    padding: 0 20px;
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    box-shadow: 0 -4px 6px #00000014;
}

.content_box1 {
    border: 1px dashed #ccc;
    padding: 20px 30px;

}

.currentPeriodBox {
    background-color: #e5ebf9;
    padding: 5px 10px;
    border-radius: 5px;
}

.timePeriodBox {
    border: 1px solid #ddd;
    padding: 5px 30px;
    color: #555;
    cursor: pointer;
}

.activeTimePeriodBox {
    background-color: #409eff;
    color: #fff;
}

.exUserBox {
    border: 1px solid #ccc;
    height: 250px;
    box-sizing: border-box;
    /* padding-top: 50px; */
    /* overflow: scroll; */
    width: 500px;
    background-color: #fff;



}

.exUserBox .topTitle {
    box-sizing: border-box;
    width: 100%;
    height: 50px;
    background-color: #e4eeff;
    border-bottom: 1px solid #ccc;
}

.exUserBox .topTitle div {
    width: 250px;
    height: 50px;
    /* padding-left: 20px; */
    text-align: center;
    box-sizing: border-box;
    line-height: 50px;
}

.exUserBox .topTitle div:first-child {
    border-right: 1px solid #ccc;
}

.qrcodeBox {
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMQAAADECAMAAAD3eH5ZAAAAVFBMVEUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA5OTlxcXEAAABmZmZ2dnaQkJCOjo7x8fH09PSXl5f6+vr8/Pz+/v7///+YmJj///+ZmZn///+SQT0dAAAAGnRSTlMAAQIDBAUGBwgJCQkKCg0+P1pfkZat4OPu+FYhr8AAAALxSURBVHja7d1Lc6swDAVgEiSZtukjTdqk4v//z7vgZYxNMncBsuecdcLoG9ksOVVVaA6mk/v8z0gOWaUAQpyR/Olx9zytMDn9Q8u64Wg0a4o0oTaRNCNlsDX/UpJQRAjDP8lEAkcMsTSEAN4tISSpCA2TgM1kcoSKBWI0jAIxkdERUcQMHqF7gNs9I8RnBIqYoSd0D2l2zQTpGAvFDDEZOoI3/8tu8SQDI1TEEO+Xu6Zy2izJEe6X9xVEb6CLptNulpUhLjRXBIuo65rorl/izrfWYG5nJ196p17hrWK2CCJWlddrazTXV1FlonAVwSJY1Zk1tO3V9Yg6iSBiVj23hnNW5WEVIWJchKjeLCNuqhKsYo4gYpYt30H/996SYBULhOSAkDiiP03M4uwjnDD752mGIGLJAzFfRZkIlwPCrSGYxTX2EU1/KZaI4TTlgRhWURzCuxJZIOaXokxEkwOiKR3BLK55sY94Cd6xQAABBBBAbIk4tcZzAgIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggAACCCCAAAIIIIAAAggggACiVAS+UgoEEEBYQ+Bb+5YQ6J/YF4FOFkOIIip+iilbQneXEUTuVXBFlPIVVI+Ye1FlEZWhxZS35l+jO65CVSwXGotqpNA4rJZWZRH38f3z+2cJ8Pf78/3hRFg1Ui0dlnzf9bPvKZ86yk+7Zeor77vKP/X+RFP5Wsn3djXrayXfa4he8bZSt75d3f1K3frbWvH9uIuaiIiZRaQ7Vzunm4OZiZa19z0iUPiMAbJ3mAPCwuAhJkVNo8NEaCCEhgiiU3SMzrEzZpqhngi+YUBEFD3Dh+yZYZpj2jBDjIzRYSXHCMFDBIqRYUbiDXRIGRYKn2EqhxXDUmEQEhmxqh4qrFiSo1XV0wqzqWIpgJCVo3qY3OfPM/8ACadI/HzwP7wAAAAASUVORK5CYII=) no-repeat;
    justify-content: center;
    align-items: center;
    width: 198px;
    height: 198px;
    display: flex;
}


.qrcodeBox img {
    height: 140px;
    width: 140px;
}

/deep/ .selectContentBox .el-checkbox__inner {
    margin-bottom: 15px !important;
}

/deep/ .input100 .el-input__inner {
    width: 100px;
}

/deep/ .input150 .el-input__inner {
    width: 150px;
}

/deep/ .input200 .el-input__inner {
    width: 200px;
}
</style>
